import React from "react";
import { withRouter } from "react-router-dom";

import Contactos from "./components/Contactos";
import TermosDireitos from "./components/TermosDireitos";
import PedidoDemonstracao from "./components/PedidoDemonstracao";
import MensagemStepforma from "./components/MensagemStepforma";

import { logo_stepforma } from "../../../assets/logos";
import styles from "./Footer.module.scss";

const Footer = () => {
    return (
        <>
            <div className={styles.footerHome}>
                <div className={`${styles.footerLeftBlock} ${styles.footerLeftBlockDesktop}`}>
                    <div className={styles.logoBlock}>
                        <img src={logo_stepforma} alt="Logo" />
                        <TermosDireitos />
                    </div>
                    <div className={styles.contactsBlock}>
                        <Contactos />
                    </div>
                </div>
                <div className={`${styles.footerLeftBlock} ${styles.footerLeftBlockLaptop}`}>
                    <div>
                        <div className={styles.footerLeftBlockTop}>
                            <div className={styles.logoBlock}>
                                <img src={logo_stepforma} alt="Logo" />
                            </div>
                            <div className={styles.contactsBlock}>
                                <Contactos />
                            </div>
                        </div>
                        <div className={styles.footerLeftBlockBottom}>
                            <TermosDireitos />
                        </div>
                    </div>
                </div>
                <div className={styles.footerSeparator}></div>
                <div className={styles.footerRightBlock}>
                    <span className={styles.requestDemoBlock}>
                        <PedidoDemonstracao />
                    </span>
                    <span className={styles.messageBlock}>
                        <MensagemStepforma />
                    </span>
                </div>
            </div>
            <div className={`${styles.footerHome} ${styles.footerHomeTablet}`}>
                <div className={styles.footerRightBlock}>
                    <span className={styles.requestDemoBlock}>
                        <PedidoDemonstracao />
                    </span>
                    <span className={styles.messageBlock}>
                        <MensagemStepforma />
                    </span>
                </div>
                <div className={styles.footerLeftBlock}>
                    <div>
                        <div className={styles.footerLeftBlockTop}>
                            <div className={styles.logoBlock}>
                                <img src={logo_stepforma} alt="Logo" />
                            </div>
                            <div className={styles.contactsBlock}>
                                <Contactos />
                            </div>
                        </div>
                        <div className={styles.footerLeftBlockBottom}>
                            <TermosDireitos />
                        </div>
                    </div>
                </div>
            </div>
            <div className={`${styles.footerHome} ${styles.footerHomeMobile}`}>
                <div className={styles.messageBlock}>
                    <MensagemStepforma />
                </div>
                <div className={styles.requestDemoBlock}>
                    <PedidoDemonstracao />
                </div>
                <div className={styles.contactsBlock}>
                    <div>
                        <Contactos />
                    </div>
                </div>
                <div className={styles.logoBlock}>
                    <img src={logo_stepforma} alt="Logo" />
                    <TermosDireitos />
                </div>
            </div>
        </>
    );
};

export default withRouter(Footer);
